<template>
    <div>
        <job-list key="active-0"
                  ref="activeList"
                  :filter="''"
                  :location-filter="null"
                  :user-filter="null"
                  active-state="active"
                  class="fixed top-96 left-96 max-w-1440"
        ></job-list>

        <div class="w-full h-full bg-primary opacity-30 absolute inset-0"></div>

        <div class="bg-white shadow-md my-64 rounded-l ml-auto -mr-48 relative z-10 p-48 w-full max-w-640">
            <popup-content :description="$t('free_trial.jobs.description')"
                           :progress="50"
                           :title="$t('free_trial.jobs.title')"
                           icon="format-list-bulleted"
            ></popup-content>


            <template v-if="allJobsLoaded">
                <b class="mt-24 mb-8 text-body-sm flex items-center">{{ $t('free_trial.jobs.job_title') }}</b>
                <span class="block mb-8 text-primary-80">
                    {{ $t('free_trial.jobs.job_description') }}
                </span>
                <simple-input v-model="jobTitle[activeLang]" class="w-1/2 mr-32"></simple-input>
            </template>
            <loading v-else></loading>

            <div class="mt-48 flex justify-center space-x-20">
                <simple-button class="uppercase w-200"
                               look="secondary"
                               @click="$emit('previous')">
                    {{ $t('general.back') }}
                </simple-button>

                <simple-button :disabled="!allJobsLoaded"
                               :loading="loading"
                               class="uppercase w-200"
                               display="secondary"
                               look="primary"
                               @click="handleNextStep">
                    {{ $t('jobs.next_step') }}
                </simple-button>
            </div>
        </div>
    </div>
</template>

<script>
import * as jobs from '../../../services/JobService';
import Job from '../../../models/Job';
import SimpleButton from '../SimpleButton.vue';
import JobList from '../../JobList.vue';
import Loading from '../Loading.vue';
import Input from '../../forms/Input.vue';
import {normalizeJson} from '../../../../shared/helpers';
import PopupContent from './PopupContent.vue';
import {mapStores} from "pinia";
import {useMainStore} from "../../../state/store";
import {useJobsStore} from "../../../state/modules/jobs";
import {useRepo} from "pinia-orm";

export default {
    name: 'Vacancy',
    components: {
        PopupContent,
        Loading,
        JobList,
        'simple-input': Input,
        'simple-button': SimpleButton,
    },
    data() {
        return {
            loading: null,
        };
    },
    computed: {
        ...mapStores(useMainStore, useJobsStore),
        fetchingJobs() {
            return this.jobsModuleStore.fetchingJobs;
        },
        allJobsFetched() {
            return this.jobsModuleStore.allJobsFetched;
        },
        currentCompany() {
            return this.mainStore.currentCompany;
        },
        activeLang() {
            return this.mainStore.locale;
        },
        allJobsLoaded() {
            return this.allJobsFetched['active'];
        },
        firstJob() {
            if (this.allJobsLoaded) {
                return useRepo(Job)
                    .where('company_id', this.currentCompany.id)
                    .where('is_spontaneous', 0)
                    .where('archived', null)
                    .with(['stages'])
                    .orderBy('sequence')
                    .first();
            }

            return null;
        },
        jobTitle: {
            get() {
                if (this.allJobsLoaded && this.firstJob) {
                    return this.firstJob.title;
                }

                return '';
            },
            set(value) {
                useRepo(Job).save({id: this.firstJob.id, title: value});
            },
        },
    },
    methods: {
        handleNextStep() {
            this.loading = true;

            jobs.update(this.firstJob.id, {data: {attributes: {title: this.jobTitle}}})
                .then(result => {
                    this.loading = false;

                    useRepo(Job).save(normalizeJson(result));

                    this.$emit('setJob', this.firstJob);
                    this.$emit('setApplication', null);

                    return this.$emit('next');
                });
        },
    },
};
</script>
